import { DateRangeSearchFilterDTO, DateRangeSearchFilterId, SearchFilterDTO } from "../..";

const textSearchTypes: Record<DateRangeSearchFilterId, true> = {
  "lease-end-date": true,
  "lease-start-date": true,
  "year-built": true,
  "planning-applications-submission-date": true,
};

export function isDateRangeSearchDTO(filter: SearchFilterDTO): filter is DateRangeSearchFilterDTO {
  return filter.id in textSearchTypes;
}
